import { forwardRef, useRef } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid var(--color-sw-10);
  border-radius: 8px;

  :focus-within {
    box-shadow: 0 3px 5px rgba(95, 99, 104, 0.05),
      0 10px 10px rgba(95, 99, 104, 0.05), 0 1px 18px rgba(95, 99, 104, 0.05);
  }
`
const Input = styled.input`
  background: none;
  border: none;
  outline: none;
  flex: 1;
  padding: 15px;
  font: var(--typography-14-16-regular);
  letter-spacing: 0.3px;
  color: var(--color-night-sky);

  ::placeholder {
    font: var(--typography-14-16-regular);
    letter-spacing: 0.3px;
    color: var(--color-sw-60);
  }

  :focus::placeholder {
    color: var(--color-sw-20);
  }
`
const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 46px;
`
const TextField = forwardRef((props, ref) => {
  const inputRef = useRef(ref)
  return (
    <Wrapper>
      <InputWrapper>
        <Input {...props} ref={inputRef} />
      </InputWrapper>
    </Wrapper>
  )
})

export default TextField
